import ButtonTable from 'components/Buttons/ButtonTableDialog';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { shipmentsBySubstance } from 'selectors/generic';


const BUTTONS_TEXT = ['Matéria Prima: ', 'Fornecimento: '];

const OPTIONS_KEY1 = [
  { title: 'CODIGO_MP', tag: 'raw_material_code' },
  { title: 'MP_NOME', tag: 'raw_material_name' }
];

// The supplier's name is put on the row below, the way the shipment panels
// already did it, rather than read through `nested: 'supplier_id'` - a shipment
// carries the supplier's id now, not the supplier.
const OPTIONS_KEY2 = [
  { title: 'CODIGO', tag: 'code' },
  { title: 'DESIGNAÇÃO COMERCIAL', tag: 'trade_name' },
  { title: 'FORNECEDOR', tag: 'name' }
  // { title: 'DATA FDS', tag: 'sds_date' },
  // { title: 'REVISÃO FDS', tag: 'sds_revision' }
];

const OPTIONS_KEYS = [OPTIONS_KEY1, OPTIONS_KEY2];

const COLUMNS = [
  { title: 'Código MP', field: 'raw_material_code' },
  { title: 'Matéria prima', field: 'raw_material_name' },
  { title: 'Fornecimento', field: 'code' },
  { title: 'Desig. Comercial', field: 'trade_name' },
  { title: 'Fornecedor', field: 'name' }
];

const Component = props => {
  const { currentOption, rawMaterialsById, shipmentsOfSubstance, substance, suppliersById } = props;
  const { onSelection } = props;

  /**
   * On shipment there should be shipment_substance or shipment_mistura to
   * signal that the Shipment is direct or indirect from others mixs instead the
   * original substance
   */
  const augmentedShipment = ({ rawMaterialId, shipment }) => {
    const supplierName = suppliersById[shipment.supplier_id].name;

    if (rawMaterialId === substance.id) {
      return {
        ...shipment,
        shipment_substance_id: substance.id,
        shipment_id_mp: substance.id,
        raw_material_name: substance.name,
        raw_material_code: substance.code,
        name: supplierName
      };
    }

    return {
      ...shipment,
      shipment_mixture_id: rawMaterialId,
      shipment_id_mp: rawMaterialId,
      raw_material_name: rawMaterialsById[rawMaterialId].name,
      raw_material_code: rawMaterialsById[rawMaterialId].code,
      name: supplierName
    };
  };

  // The substance's own shipments first, then those of the mixtures it is part
  // of - the same order the two loops built.
  const shipments = (shipmentsOfSubstance[substance.id] || []).map(augmentedShipment);

  const augmentedCurrentOption =
    shipments.find(shipment => currentOption.id === shipment.id) || {};

  return (
    <ButtonTable
      buttonsText={BUTTONS_TEXT}
      currentOption={augmentedCurrentOption}
      header='Seleccione um Fornecimento'
      optionKeys={OPTIONS_KEYS}
      options={shipments}
      onSelection={onSelection}
      columns={COLUMNS}
      maxWidth='xl'
    />
  );
};

const mapStateToProps = (state, props) => ({
  rawMaterialsById: state.rawMaterials.models,
  shipmentsOfSubstance: shipmentsBySubstance(state),
  suppliersById: state.suppliers.models
});

export default connect(mapStateToProps)(Component);

Component.propTypes = {
  currentOption: PropTypes.object,
  onSelection: PropTypes.func.isRequired
};
